import { toast } from '@cma/common'
import pluralize from 'pluralize'
import { useContent } from './ContentContext'
import { useCreatePlatformClientContent } from './useCreatePlatformClientContent'

interface ContentFileUploaderProps {
  inputRef: React.RefObject<HTMLInputElement>
  isUploading?: (isUploading: boolean) => void
  onFilesSizeChange?: (totalFiles: number) => void
}

export function ContentFileUploader({
  inputRef,
  isUploading,
  onFilesSizeChange
}: ContentFileUploaderProps) {
  const { currentFolderId } = useContent()
  const { mutate: uploadContent } = useCreatePlatformClientContent()

  return (
    <input
      ref={inputRef}
      type="file"
      accept=".pdf"
      multiple
      className="hidden"
      onChange={(evt) => {
        const files = evt.target.files
        if (!files || !files.length) return

        const pdfFiles = Array.from(files).filter(
          (file) =>
            file.type === 'application/pdf' || file.name.endsWith('.pdf')
        )

        if (pdfFiles.length !== files.length) {
          toast('Only PDF files are allowed', { variant: 'error' })
          if (inputRef.current) inputRef.current.value = ''
          return
        }

        const totalFiles = pdfFiles.length
        onFilesSizeChange?.(totalFiles)
        isUploading?.(true)

        uploadContent(
          {
            input: {
              folderId: currentFolderId,
              files: pdfFiles
            }
          },
          {
            onSuccess() {
              toast(`${pluralize('File', totalFiles)} uploaded successfully`, {
                variant: 'success'
              })
            },
            onError(error) {
              toast(error.message, { variant: 'error' })
            },
            onSettled() {
              isUploading?.(false)
              if (inputRef.current) {
                inputRef.current.value = ''
              }
            }
          }
        )
      }}
    />
  )
}
